import { delay, http, HttpResponse } from 'msw';

import { ChatDto } from '../../model';

export const getChatQueryMocked = http.get<{ id: string }>('/api/chat/:id', async ({ params }) => {
  const chatId = params.id;
  const chatQuery: ChatDto = JSON.parse(JSON.stringify(mockChatQuery));

  chatQuery.chat.id = parseInt(chatId);
  chatQuery.job.chat = parseInt(chatId);

  await delay(1500);

  return HttpResponse.json<ChatDto>(chatQuery);
});

const mockChatQuery: ChatDto = {
  chat: {
    id: 8,
    created_at: '2025-11-20T10:50:10.556322Z',
    campaign: 2876,
    job_improved_id: null,
  },
  recommendations: null,
  messages: [
    {
      id: 83,
      role: 'user',
      content: 'I need a frontend developer',
      created_at: '2025-11-20T10:50:10.567718Z',
      chat: 8,
    },
    {
      id: 84,
      role: 'assistant',
      content: 'Could you please provide the job location (city)?',
      created_at: '2025-11-20T10:50:13.443824Z',
      chat: 8,
    },
    {
      id: 85,
      role: 'user',
      content: 'Utrecht',
      created_at: '2025-11-20T10:50:20.156601Z',
      chat: 8,
    },
    {
      id: 86,
      role: 'assistant',
      content: 'What are the key responsibilities for this frontend developer position?',
      created_at: '2025-11-20T10:50:23.615468Z',
      chat: 8,
    },
    {
      id: 87,
      role: 'user',
      content: 'Idk, could you please recommend some?',
      created_at: '2025-11-20T10:50:34.967925Z',
      chat: 8,
    },
    {
      id: 88,
      role: 'assistant',
      content: 'Do you have any specific requirements for candidates?',
      created_at: '2025-11-20T10:50:37.747012Z',
      chat: 8,
    },
    {
      id: 89,
      role: 'user',
      content:
        'Develop and maintain user-facing features\nEnsure the technical feasibility of UI/UX designs\nOptimize applications for maximum speed and scalability\nCollaborate with backend developers and designers\nWrite clean, maintainable, and efficient code',
      created_at: '2025-11-20T10:58:38.915959Z',
      chat: 8,
    },
    {
      id: 90,
      role: 'assistant',
      content: 'What are the requirements for candidates applying for this frontend developer role?',
      created_at: '2025-11-20T10:58:44.935435Z',
      chat: 8,
    },
    {
      id: 91,
      role: 'user',
      content: 'Idk',
      created_at: '2025-11-20T11:00:55.442160Z',
      chat: 8,
    },
    {
      id: 92,
      role: 'assistant',
      content: 'What is the salary range for this frontend developer position?',
      created_at: '2025-11-20T11:00:58.487075Z',
      chat: 8,
    },
    {
      id: 93,
      role: 'user',
      content:
        'Experience with React or Angular frameworks\nProficiency in HTML, CSS, and JavaScript\nUnderstanding of responsive design principles\nGood problem-solving skills\nAbility to work in a team environment',
      created_at: '2025-11-20T11:01:05.913233Z',
      chat: 8,
    },
    {
      id: 94,
      role: 'assistant',
      content: 'What is the salary range and salary unit for this frontend developer position?',
      created_at: '2025-11-20T11:01:12.824356Z',
      chat: 8,
    },
    {
      id: 95,
      role: 'user',
      content: '3000-3750 eur',
      created_at: '2025-11-20T11:01:29.815942Z',
      chat: 8,
    },
    {
      id: 96,
      role: 'assistant',
      content: 'What is the salary unit? Is it monthly, hourly, or annual?',
      created_at: '2025-11-20T11:01:33.196791Z',
      chat: 8,
    },
    {
      id: 97,
      role: 'user',
      content: 'montly',
      created_at: '2025-11-20T11:02:07.607019Z',
      chat: 8,
    },
    {
      id: 98,
      role: 'assistant',
      content: 'What are the working hours for this frontend developer position?',
      created_at: '2025-11-20T11:02:11.524040Z',
      chat: 8,
    },
    {
      id: 99,
      role: 'user',
      content: 'actually, ill be 20 to 25 eur / hour',
      created_at: '2025-11-20T11:04:21.654284Z',
      chat: 8,
    },
    {
      id: 100,
      role: 'assistant',
      content: 'What are the expected working hours per week for this frontend developer position?',
      created_at: '2025-11-20T11:04:23.793077Z',
      chat: 8,
    },
    {
      id: 101,
      role: 'user',
      content: '25 to 40 hours',
      created_at: '2025-11-20T11:10:39.762698Z',
      chat: 8,
    },
    {
      id: 102,
      role: 'assistant',
      content: 'Do you want to specify the employment type (e.g., Full-time, Part-time) or should I keep it as is?',
      created_at: '2025-11-20T11:10:42.555818Z',
      chat: 8,
    },
    {
      id: 103,
      role: 'user',
      content: 'sorry, typo. I mean 35 to 45 hours/week',
      created_at: '2025-11-20T11:11:19.872738Z',
      chat: 8,
    },
    {
      id: 104,
      role: 'assistant',
      content: 'What is the employment type for this frontend developer position?',
      created_at: '2025-11-20T11:11:24.644171Z',
      chat: 8,
    },
    {
      id: 105,
      role: 'user',
      content: 'nah, let me change again. 40 hours week, full time, 3000 to 5000 eur /month',
      created_at: '2025-11-20T11:12:35.952410Z',
      chat: 8,
    },
    {
      id: 106,
      role: 'assistant',
      content: 'Do you want to add any information about compensation benefits or certificates?',
      created_at: '2025-11-20T11:12:39.718056Z',
      chat: 8,
    },
    {
      id: 107,
      role: 'user',
      content: '8% vakantiegeld\nPensioenregeling\nFlexibele werktijden\nOpleidingsbudget\nHeftruckcertificaat\nVCA',
      created_at: '2025-11-20T11:12:57.279217Z',
      chat: 8,
    },
    {
      id: 108,
      role: 'assistant',
      content: "Is there anything else you'd like to add or update for this job posting?",
      created_at: '2025-11-20T11:13:00.239347Z',
      chat: 8,
    },
    {
      id: 109,
      role: 'user',
      content: 'having figma skill is a differential',
      created_at: '2025-11-20T11:14:38.895221Z',
      chat: 8,
    },
    {
      id: 110,
      role: 'assistant',
      content: 'Would you like to update the requirements to include Figma skills as a differential?',
      created_at: '2025-11-20T11:14:41.124732Z',
      chat: 8,
    },
    {
      id: 111,
      role: 'user',
      content: 'yes',
      created_at: '2025-11-20T11:14:44.403910Z',
      chat: 8,
    },
    {
      id: 112,
      role: 'assistant',
      content: "Anything else you'd like to add or update?",
      created_at: '2025-11-20T11:14:46.774778Z',
      chat: 8,
    },
  ],
  job: {
    job_title: 'frontend developer',
    job_preview:
      "<h3><strong>Quick facts</strong></h3>\n<ul>\n  <li><strong>Role:</strong> frontend developer</li>\n  <li><strong>Location:</strong> Utrecht</li>\n  <li><strong>Hours:</strong> 40 - 40</li>\n  <li><strong>Pay:</strong> €3500.00 – €5000.00 per month</li>\n  <li><strong>Requirements:</strong> Experience with React or Angular, proficiency in HTML, CSS, and JavaScript, knowledge of responsive design, team player</li>\n</ul>\n\n<h3><strong>What you'll do</strong></h3>\n<p>As a frontend developer, you are responsible for developing and maintaining high-quality, user-friendly features. You work closely with designers and backend developers to ensure the technical feasibility of UI/UX designs and optimize applications for performance and scalability. Your work delivers a seamless and engaging digital experience for our users.</p>\n\n<h3><strong>Your day looks like this</strong></h3>\n<ul>\n  <li>Developing and maintaining user-facing features</li>\n  <li>Ensuring technical feasibility of UI/UX designs</li>\n  <li>Optimizing applications for maximum speed and scalability</li>\n  <li>Collaborating with backend developers and designers</li>\n  <li>Writing clean, maintainable, and efficient code</li>\n</ul>\n\n<h3><strong>What you get</strong></h3>\n<ul>\n  <li>8% holiday allowance</li>\n  <li>Pension scheme</li>\n  <li>Flexible working hours</li>\n  <li>Personal learning & development budget</li>\n</ul>\n\n<h3><strong>What we ask</strong></h3>\n<ul>\n  <li>Experience with React or Angular frameworks</li>\n  <li>Proficiency in HTML, CSS, and JavaScript</li>\n  <li>Understanding of responsive design principles</li>\n  <li>Good problem-solving skills</li>\n  <li>Ability to work in a team environment</li>\n  <li>Figma skill is a differential</li>\n</ul>",
    address: null,
    certificates: null,
    chat: 8,
    id: 8,
    compensation_benefits: null,
    employment_type: null,
    min_salary: null,
    max_salary: null,
    salary_unit: null,
    created_at: '2025-11-20T10:50:10.556322Z',
    updated_at: '2025-11-20T10:50:10.556322Z',
    latitude: null,
    longitude: null,
    radius_km: null,
    detected_language: null,
    position_description: null,
    education_level: null,
    language: null,
    driver_license: null,
    key_responsibilities: null,
    language_level: null,
    requirements: null,
    shifts: null,
    workdays: null,
    tenant: 1,
    user: 1675,
    working_hours_range: null,
  },
};
